<template>
    <div v-if="mediaItem.type < 2">
        <v-img
                :src="preview"
                height="120"
                class="text-right pa-2"
                :alt="mediaItem.caption"
        />
        <span class="font-weight-light">{{mediaItem.caption}}</span>
    </div>
    <v-card v-else flat>
        <div class="pa-1">
            <div class="text-center mb-1">
                <v-icon large>insert_drive_file</v-icon>
            </div>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <span v-on="on" class="font-weight-light">{{mediaItem.caption}}</span>
                </template>

                <div>{{mediaItem.caption}}</div>
            </v-tooltip>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'DocumentCard',
    props: {
        mediaItem: Object
    },
    computed: {
        preview() {
            return this.mediaItem.type === 0 ? this.mediaItem.link : '/static/video.jpg'
        }
    }
}
</script>

<style scoped>

</style>
